import React from "react";
import { Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleHomeRedirect = () => {
    navigate("/");
  };

  const handleBack = () => {
    navigate(-1); // Wróć do poprzedniej strony
  };

  return (
    <Modal
      title="Brak dostępu"
      open={true}
      width={600}
      onCancel={handleHomeRedirect}
      centered
      footer={[
        <Button key="back" onClick={handleBack}>
          Wróć
        </Button>,
        <Button key="home" type="primary" onClick={handleHomeRedirect}>
          Strona główna
        </Button>,
      ]}
    >
      <p>
        Wygląda na to, że nie posiadasz wystarczających uprawnień, aby uzyskać dostęp do tego obszaru.
        <br />
        Jeśli uważasz, że to błąd, skontaktuj się z administratorem lub działem technicznym.
      </p>
    </Modal>
  );
};

export default AccessDenied;
